import { useMemo } from 'react';

import { Heading, HStack, type HStackProps } from '@frontend/legacy-components';

import { CASCADER_SUBCOMPONENT_NAMES } from '../consts';
import { useCascaderState, useCascaderComponentsContext } from '../context';
import type { CascaderOption, CascaderCommonProps } from '../types';

export interface SubmenuGroupHeaderProps<OptionType extends CascaderOption>
  extends HStackProps {
  label: string;
  getCommonProps: () => CascaderCommonProps<OptionType>;
}

export const InternalSubmenuGroupHeader = <OptionType extends CascaderOption>({
  label,
}: {
  label: string;
}) => {
  const { cascaderStyles, getCommonProps } = useCascaderState<OptionType>();
  const { getComponent } = useCascaderComponentsContext<OptionType>();
  const CustomSubmenuGroupHeader = useMemo(
    () => getComponent(CASCADER_SUBCOMPONENT_NAMES.SUBMENU_GROUP_HEADER),
    [getComponent],
  );

  return (
    <CustomSubmenuGroupHeader
      getCommonProps={getCommonProps}
      __css={cascaderStyles.submenuGroupHeader}
      label={label}
      className="cascader-submenu-group-header"
    />
  );
};

export const SubmenuGroupHeader = <OptionType extends CascaderOption>({
  label,
  getCommonProps: _,
  ...rest
}: SubmenuGroupHeaderProps<OptionType>) => {
  return (
    <HStack {...rest}>
      <Heading
        size="sm"
        as="span"
        flexGrow={1}
        textAlign="left"
        px={2}
        color="feature.secondary"
        textTransform="uppercase"
      >
        {label}
      </Heading>
    </HStack>
  );
};
